<li class="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white dark:bg-zinc-900  text-center shadow">
    <div
        class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10">
        <div class="p-2 relative">

            @switch (video.status) {
            <!-- New Video -->
            @case (0) {
            <span
                class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-sky-100 px-1.5 py-0.5 text-xs font-medium text-sky-600">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-sky-500">
                    <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                    <path d="M15 8h6" />
                    <path d="M18 5v6" />
                    <path
                        d="M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332" />
                </svg>
                New
            </span>
            }
            <!-- Seen Video -->
            @case (1) {
            <span
                class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-fuchsia-100 px-1.5 py-0.5 text-xs font-medium text-fuchsia-600">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-fuchsia-500">
                    <path
                        d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                    <circle cx="12" cy="12" r="3" />
                </svg>
                Seen
            </span>
            }
            <!-- Approved Video -->
            @case (2) {
            @if (licenseSlot() === 'licensed') {
            <span data-testid="badge-ad-licensed"
                class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-[#6508FB] px-1.5 py-0.5 text-xs font-medium text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4" aria-hidden="true">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                    <path d="m9 12 2 2 4-4" />
                </svg>
                Ad Licensed
            </span>
            } @else if (licenseSlot() === 'pending') {
            <span data-testid="badge-license-pending"
                class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-[#2B2340] px-1.5 py-0.5 text-xs font-medium text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 6v6l4 2" />
                </svg>
                License Pending
            </span>
            } @else {
            <span
                class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-green-100 px-1.5 py-0.5 text-xs font-medium text-green-600">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-green-500">
                    <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                    <path d="m9 11 3 3L22 4" />
                </svg>
                Approved
            </span>
            }
            }
            <!-- Declined Video -->
            @case (3) {
            <span
                class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-orange-100 px-1.5 py-0.5 text-xs font-medium text-orange-600">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-orange-500">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M16 16s-1.5-2-4-2-4 2-4 2" />
                    <line x1="9" x2="9.01" y1="9" y2="9" />
                    <line x1="15" x2="15.01" y1="9" y2="9" />
                </svg>
                Declined
            </span>
            }
            }

            <!-- 
            <vs-video-thumbnail [videoUrl]="video.fullUrl" [videoId]="video.id"
                [thumbnailURL]="video.thumbnailURL ? video.thumbnailURL : undefined"
                [cdnKey]="video.thumbnailCdnKey ? video.thumbnailCdnKey : undefined" [videoFormat]="videoFormat"
                (click)="openViewer($event)"></vs-video-thumbnail> -->

            <atom-video-thumbnail (click)="openViewer($event)" [videoUrl]="video.fullUrl"
                [thumbnailURL]="video.thumbnailURL ? video.thumbnailURL : undefined"
                [cdnKey]="video.thumbnailCdnKey ? video.thumbnailCdnKey : undefined"
                [videoFormat]="videoFormat"></atom-video-thumbnail>

        </div>
        <div class="px-3 py-3 flex flex-col gap-y-2">
            <div class="flex flex-row w-full items-center justify-between">
                <div class="flex flex-row items-center gap-x-1">
                    <p class="text-xs text-secondary"> {{ formatService.getTimeSinceUpdated(video.createdDate) }}</p>
                </div>

                @if (videoAiModerateService.noodleVisible().draft_item) {
                @if (video.aiModerateScore) {
                <span class="inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-sm font-medium"
                    [appTooltip]="'The brief accuracy score'" position="top"
                    [class]="getModerateScoreClass(video.aiModerateScore)">
                    <svg viewBox="0 0 6 6" aria-hidden="true" class="size-1.5 fill-current">
                        <circle r="3" cx="3" cy="3" />
                    </svg>
                    {{ video.aiModerateScore }}%
                </span>
                } @else {
                <span [appTooltip]="'AI is reviewing this video'" position="top"
                    class="inline-flex items-center gap-x-1.5 rounded-full bg-gray-100 px-2 py-1 text-xs text-gray-600 dark:bg-gray-400/10 dark:text-gray-400">
                    <svg viewBox="0 0 6 6" aria-hidden="true" class="size-1.5 fill-gray-400">
                        <circle r="3" cx="3" cy="3" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-4">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>

                </span>
                }
                }

            </div>

            <!-- Actions -->
            <div class="flex flex-row items-center gap-x-2">

                <!-- Download -->
                @if (video.status === VideoStatusEnum.Accepted) {
                @if (uploadService.isDownloading()) {
                <svg aria-hidden="true"
                    class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-secondary fill-primary"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                </svg>
                } @else {
                <button (click)="downloadContent()" [appTooltip]="'Download'" position="top" type="button"
                    class="btn-fab-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="M12 15V3" />
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <path d="m7 10 5 5 5-5" />
                    </svg>
                </button>
                }
                }
                <!-- Download END -->

                <!-- Ad License slot -->
                <vs-ad-license-slot *appHasRole="[77]" class="flex-1" [videoStatus]="video.status" [quote]="licenseQuote()" [license]="license()"
                    (buy)="onBuyLicense()" (cancel)="onCancelLicense()"></vs-ad-license-slot>


                <!-- Approve Video -->
                @if ((video.status === VideoStatusEnum.Seen || video.status === VideoStatusEnum.New) &&
                (!viewSubManageService.approvedVideos() || viewSubManageService.approvedVideos()!.length <
                    viewSubManageService.requiredVideos())) { <button (click)="triggerVideoApproval(video)"
                    [appTooltip]="approvingVideo() ? 'Approving…' : 'Approve Video'" position="top" type="button"
                    [disabled]="approvingVideo()" [attr.aria-busy]="approvingVideo() ? 'true' : null"
                    class="primary-button-success inline-flex items-center justify-center flex-1 disabled:opacity-60 disabled:cursor-not-allowed">
                    @if (approvingVideo()) {
                    <svg aria-hidden="true" class="size-5 text-current animate-spin" viewBox="0 0 100 101" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor" fill-opacity="0.2" />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor" />
                    </svg>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5" aria-hidden="true">
                        <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                        <path d="m9 11 3 3L22 4" />
                    </svg>
                    }
                    </button>
                    }
                    <!-- Approve Video END -->

                    <!-- View & Details -->
                    @if (video.status === VideoStatusEnum.Accepted) {
                    <button (click)="openViewer($event)" [appTooltip]="'View & Details'" position="top" type="button"
                        class="btn-fab-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path
                                d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                        </svg>
                    </button>
                    } @else {
                    <button (click)="openViewer($event)" [appTooltip]="'View & Details'" position="top" type="button"
                        class="primary-button inline-flex items-center justify-center flex-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path
                                d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                        </svg>
                    </button>
                    }
                    <!-- View & Details END -->




            </div>
            <!-- Actions END -->


        </div>
    </div>

</li>